// @ts-nocheck
import { Outlet, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import WhatsAppFloatButton from "components/home/WhatsAppFloatButton";
import { AppDataProvider } from "context/AppDataContext";

const HomeLayout = () => {
  const { pathname } = useLocation();

  return (
    <AppDataProvider>
    <div className="min-h-screen flex flex-col w-full overflow-x-hidden" style={{ background: "#0b1228" }}>
      <main className="flex-1 w-full">
        <AnimatePresence mode="wait">
          <motion.div
            key={pathname}
            className="w-full"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{    opacity: 0 }}
            transition={{ duration: 0.35, ease: "easeInOut" }}
          >
            <Outlet />
          </motion.div>
        </AnimatePresence>
      </main>

      <WhatsAppFloatButton
        phone="601168786103"
        message="Hi IKA, I'd like to know more about your programs!"
      />
    </div>
    </AppDataProvider>
  );
};

export default HomeLayout;
